// Module
var code = "<div class=\"breadcrumb\"> <breadcrumb-token *ngFor=\"let token of tokens$ | async; let isLast = last;\" [ngClass]=\"token.styleClass\" [token]=\"token\" [lastToken]=\"isLast\" (tokenSelected)=\"navigate($event)\"></breadcrumb-token> </div>";
// Exports
module.exports = code;